<section (click)="onClick()">
	<i class="fal fa-times-circle fa-2x"></i>
	<div>
		<img src="{{imageSource}}" alt=""/>
	</div>
</section>
